import React, { Component } from 'react';
import PostInfoInjector from '../../../../library/board/PostInfoInjector';
import dynamic from 'next/dynamic';
const findAndReplaceDOMText = dynamic(() => import('findandreplacedomtext'), {
    ssr: false,
});

class PostTitleViewer extends Component {
    static defaultProps = {
        searchText: '',
        searchWrap: '',
        searchWrapClass: '',
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.postInfo.id !== this.props.postInfo.id) {
            if (this.props.searchText !== '') {
                if (this.postTitle) {
                    import('findandreplacedomtext').then((res) => {
                        res.default(this.postTitle, {
                            find: this.props.searchText,
                            wrap: this.props.searchWrap,
                            wrapClass: this.props.searchWrapClass,
                        });
                    });
                }
            }
        }
    }

    componentDidMount() {
        if (this.props.searchText !== '') {
            if (this.postTitle) {
                import('findandreplacedomtext').then((res) => {
                    res.default(this.postTitle, {
                        find: this.props.searchText,
                        wrap: this.props.searchWrap,
                        wrapClass: this.props.searchWrapClass,
                    });
                });
            }
        }
    }

    render() {
        const { classname = '' } = this.props;
        let title = this.props.postInfo ? this.props.postInfo.title : '';
        return (
            <span ref={(ref) => (this.postTitle = ref)} className={classname}>
                {title}
            </span>
        );
    }
}

export default PostInfoInjector()(PostTitleViewer);
